import {API_AUTH_EXPIRED_EVENT, api, isApiAuthTokenSet, removeApiAuthToken, setApiAuthToken} from "@/middleware/api";
import {AUTH_ACCESS_TOKEN_KEY} from "@/services/admin-session.mjs";
import store from "@/store";
export const DEFAULT_LOGIN_URL = '/'

if (typeof window !== 'undefined') {
    window.addEventListener(API_AUTH_EXPIRED_EVENT, () => {
        store.dispatch('user/LOGOUT')
        const loginUrl = new URL(DEFAULT_LOGIN_URL, window.location.origin)
        loginUrl.searchParams.set('session', 'expired')
        window.location.replace(loginUrl.toString())
    })
}


export const DEFAULT_ROLE_URL = {
    OWNER: 'news',
    ADMIN: 'news',
    EMPLOYEE: 'news'
}
export function getUserAuthToken() {
    return localStorage.getItem(AUTH_ACCESS_TOKEN_KEY)
}

export function setUserAuthToken(token) {
    return localStorage.setItem(AUTH_ACCESS_TOKEN_KEY, token)
}

export function removeUserAuthToken() {
    return localStorage.removeItem(AUTH_ACCESS_TOKEN_KEY)
}

export async function handleAuthMiddleware() {
    const authToken = getUserAuthToken();
    if (authToken) {
        if (!isApiAuthTokenSet(authToken)) {
            setApiAuthToken(getUserAuthToken())
            if (!store.state.user.me) {
                try {
                    let currentUser = await api.auth.authControllerAuthMe().then(r => r.data);
                    store.dispatch('user/USER', currentUser)
                    store.dispatch('partners/fetchPartners')
                } catch (err) {
                    if (err.response?.status === 401) {
                        removeUserAuthToken()
                        removeApiAuthToken()
                        store.dispatch('user/LOGOUT')
                    }
                }
            }
        }
    } else {
        if (!isApiAuthTokenSet(undefined))
            removeApiAuthToken()
        if (store.state.user.me)
            await store.dispatch('user/LOGOUT')
    }
}

export function handleAuthorizedRoute() {
}
